import(/* webpackMode: "eager" */ "/var/www/zamzam/web/src/app/[locale]/(server-styles-loader)/(main-with-own-layout)/terms/page.tsx");
